<template>
<span
  class="tickets-documentation"
  v-if="ticket"
>
    <input
      type="file"
      ref="filesContainer"
      accept="application/pdf"
      :readonly="unabled"
      style="display:none"
      @change="handleFiles($event)"
      multiple
    >
    <button
      :disabled="unabled"
      class="btn btn-fill btn-block"
      @click.prevent="handleSelectFiles()"
    >Enviar Documentação</button>
    <p v-for="selectedFile in selectedFiles" :key="selectedFile">{{ selectedFile }}</p>
    <button
      type="submit"
      v-if="this.selectedFiles.length !== 0"
      :disabled="unabled"
      @click.prevent="handleSave()"
      class="btn btn-fill btn-block btn-success btn-wd"
    >
      <i class="ti-save"></i> Salvar
    </button>
  </span>
</template>
<script>
import Couchdb from 'src/services/Couchdb'
import swal from 'sweetalert2'
import { mapActions, mapGetters } from 'vuex'

export default {
  data () {
    return {
      isLoadingFile: false,
      selectedFiles: [],
      binaryFiles: [],
      saving: false,
      loading: false
    }
  },
  computed: {
    ...mapGetters('tickets', {
      ticket: 'ticket'
    }),
    ...mapGetters('events', {
      event: 'event'
    }),

    unabled: function () {
      let blockByWinner = !this.ticket.winner && this.event.winnerChoiceMode === 'ranking'
      return this.saving || !this.ticket.stockId || !this.$can('tickets.uploadDoc') || blockByWinner
    }
  },

  methods: {
    ...mapActions('tickets', ['updateState']),

    loadFile (file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.onload = function (e) {
          resolve(e.target.result)
        }
        reader.onerror = function (e) {
          reject(e)
        }
        reader.readAsArrayBuffer(file)
      })
    },

    handleSelectFiles () {
      this.$refs.filesContainer.click()
    },

    handleSelectFile () {
      this.$refs.filesContainer.click()
    },

    handleFiles (data) {
      this.isLoadingFile = true
      let files = data.target.files
      Array.prototype.forEach.call(files, file => {
        this.selectedFiles.push(file.name)
        this.loadFile(file)
          .then(binaryFile => {
            this.isLoadingFile = false
            this.binaryFiles.push(binaryFile)
          })
      })
    },

    async handleSave () {
      this.saving = true
      if (this.binaryFiles === null && Array.isArray(this.binaryFiles) && this.binaryFiles.length === 0) {
        swal({
          text: `Nenhum arquivo foi selecionado.`,
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        })
      } else {
        this.isLoadingFile = true

        for (const index in this.binaryFiles) {
          const binaryFile = this.binaryFiles[index]
          let docId
          let referenceDoc = await Couchdb.connection('docs')
            .view(
              'docs-by-reference-id',
              'docs-by-reference-id',
              this.ticket._id
            )
          referenceDoc = referenceDoc.rows[0] && referenceDoc.rows[0].value ? referenceDoc.rows[0].value : false

          if (referenceDoc) {
            docId = referenceDoc._id
          } else {
            let doc = await Couchdb.connection('docs')
              .insert({
                database: 'trg_admin',
                referenceId: this.ticket._id
              })
            docId = doc.id
          }

          await Couchdb.connection('docs')
            .insertAttachment(docId, {
              mimeType: 'application/pdf',
              attachmentName: this.selectedFiles[index],
              attachment: binaryFile
            })
          console.log(referenceDoc)
        }

        let date = new Date()
        let doc = Object.assign({}, this.ticket, { documentedAt: date })

        delete doc.customer
        delete doc.event
        delete doc.stock

        await Couchdb.connection('default')
          .updateWithView({
            ddoc: 'tickets-by-id',
            view: 'tickets-by-id',
            payload: doc,
            database: 'default'
          })
          .then(result => {
            this.updateState({ documentedAt: date })
            this.resetFile()
            this.isLoadingFile = false
            this.$notify({
              message: 'Documentação salva com sucesso.',
              type: 'success'
            })
            window.location.reload()
          })
          .catch(err => console.log(err))
      }

      this.saving = false
    },
    resetFile () {
      this.selectedFiles = []
      this.binaryFiles = []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Tickets/Actions/TicketsDocumentation.vue